<script lang="ts">
  import { Container } from '@shared/ui/container';
  import { DivideLine } from '@shared/ui/divide-line';
  import { HoverLink } from '@shared/ui/links/hover-link';
  import { cn } from '@shared/utils';

  export let title: string;
  export let titleClass = '';
  export let wrapperClass = '';
  export let containerClass = '';
  export let link = '';
  export let align: 'center' | 'end' = 'end';
  export let dividePosition: 'top' | 'bottom' | 'none' = 'bottom';
  export let counter: number | null = null;
  export let tag: 'h1' | 'h2' | 'h3' | 'p' = 'p';
</script>

{#if dividePosition === 'top'}
  <DivideLine />
{/if}

<Container containerClass="{cn('my-8 lg:my-9', containerClass)}">
  <div class="{cn('flex items-end justify-between', { 'justify-center': align === 'center' }, wrapperClass)}">
    <svelte:element
      this="{tag}"
      class="{cn('inline-block text-4xl font-medium leading-none md:text-5xl lg:text-6xl', titleClass)}"
    >
      <!-- eslint-disable-next-line -->
      {@html title}

      {#if counter}
        <span class="align-top text-xs font-medium">{counter}</span>
      {/if}
    </svelte:element>

    {#if link}
      <HoverLink {link}>view all</HoverLink>
    {/if}

    <slot />
  </div>
</Container>

{#if dividePosition === 'bottom'}
  <DivideLine />
{/if}
